import axios from 'axios';

const QUOTE_STATUS_COLOR = {
  sent: 'warning',
  accepted: 'success',
  declined: 'error',
  expired: 'default',
  superseded: 'default',
  withdrawn: 'default',
};

export const quoteStatusLabel = (quote, t) => {
  if (quote.status === 'sent') {
    return quote.acceptance_requested ? t('quoteSnapshot.statusSent') : t('quoteSnapshot.statusSentNoAcceptance');
  }
  const key = {
    accepted: 'quoteSnapshot.statusAccepted',
    declined: 'quoteSnapshot.statusDeclined',
    expired: 'quoteSnapshot.statusExpired',
    superseded: 'quoteSnapshot.statusSuperseded',
    withdrawn: 'quoteSnapshot.statusWithdrawn',
  }[quote.status];
  return key ? t(key) : quote.status;
};

export const quoteStatusColor = (quote) => QUOTE_STATUS_COLOR[quote.status] || 'default';

// Opens the stored snapshot PDF of one sent version in a new tab.
export const openStoredQuotePdf = async (quote) => {
  const response = await axios.get(quote.pdf_url, { params: { preview: 'true' }, responseType: 'blob' });
  const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
  window.open(url, '_blank');
};
